import {
  FC,
  PropsWithChildren,
  ReactElement,
  createContext,
  useCallback,
  useMemo,
  useState,
} from "react";
import {
  PopupContextType,
  SnackBarType,
  SnackBarProviderType,
  defaultContextValue,
} from "../../Types/PopupContextType/PopupContextTypes";
import {
  Alert,
  Modal,
  Slide,
  Snackbar,
  SlideProps,
  IconButton,
  Box,
  Typography,
  useTheme,
} from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import { SetStateFunctionType } from "../../EMR/types";
export const PopupContext =
  createContext<SnackBarProviderType>(defaultContextValue);
const style = {
  // position: "absolute" as "absolute",
  // top: "50%",
  // left: "50%",
  // transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "3px",
};
function PopupProvider({ children }: PopupContextType) {
  const theme = useTheme();
  const [snackbar, setSnackBar] = useState<SnackBarType>({
    open: false,
    message: "",
    duration: 2000,
    variant: undefined,
    origin: { horizontal: "center", vertical: "top" },
    direction: "down",
    onClose: undefined,
  });

  // const [openModal, setOpenModal] = useState<boolean>(false);

  const showSnackbar = useCallback((params: SnackBarType) => {
    // console.log("params------>",params);
    setSnackBar((prev) => ({
      ...prev,
      ...params,
      origin: params.origin ? params.origin : snackbar.origin,
    }));
  }, []);

  // const handleModal = useCallback((open: boolean) => {
  //   setOpenModal(open);
  // }, []);

  const closeSnackbar = useCallback(() => {
    // console.log("snackbar----------->",snackbar);
    if (snackbar?.onClose) {
      snackbar?.onClose();
    }
    setSnackBar((prevSnackbar) => ({
      ...prevSnackbar,
      open: false,
      message: "",
      variant: undefined,
      onClose: undefined,
      duration: 2000,
    }));
  }, [snackbar]);

  const CustomModal: FC<
    PropsWithChildren<{
      title?: string | ReactElement;
      open: boolean;
      setOpen: SetStateFunctionType<boolean>;
      handleClose?: Function;
    }>
  > = ({ children, title, open, setOpen, handleClose }) => {
    const closeModal = () => {
      if (handleClose) {
        handleClose();
      } else {
        setOpen(false);
      }
    };
    return (
      <Modal
        open={open}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <>
          <div className="w-fit h-fit border-0 flex flex-col ">
            <Box sx={{ ...style }} className="">
              <Box sx={{}} className="flex justify-between px-4 py-2 border-b">
                {typeof title == "string" ? (
                  <Typography
                    color={theme.palette.grey[700]}
                    variant="h6"
                    fontSize={"1rem"}
                    fontWeight={600}
                  >
                    {title || ""}
                  </Typography>
                ) : (
                  title || ""
                )}
                <IconButton
                  size="small"
                  color="error"
                  sx={{
                    padding: "2px",
                    // color: "white",
                    // ":hover": { backgroundColor: "red" },
                  }}
                  onClick={closeModal}
                >
                  <CancelIcon />
                </IconButton>
              </Box>
              {children}
            </Box>
          </div>
        </>
      </Modal>
    );
  };

  const providerValue = useMemo(
    () => ({
      showSnackbar,
      // handleModal,
      CustomModal,
    }),
    [
      showSnackbar,
      //  handleModal,
      //  openModal
    ]
  );

  const Transition = (props: SlideProps) => {
    return <Slide {...props} direction={snackbar.direction} />;
  };
  return (
    <PopupContext.Provider value={providerValue}>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={snackbar.duration == 0 ? 1000 : snackbar.duration}
        anchorOrigin={snackbar.origin}
        sx={{ minWidth: "20%", height: "fit-content" }}
        key={new Date().toTimeString()}
        onClose={closeSnackbar}
        TransitionComponent={Transition}
      >
        <Alert
          severity={snackbar.variant}
          variant="filled"
          sx={{ width: "100%" }}
          onClose={closeSnackbar}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      {children}
    </PopupContext.Provider>
  );
}

export default PopupProvider;
